<template>
  <div>
    <div id="custom-header-bg" class="d-sm-down-none m-0">
      <img
        style="max-width: -webkit-fill-available"
        src="../assets/img/bgProfile.png"
      />
      <div id="example" class="box-shadow-profile">
        <CRow>
          <CCol sm="1">
            <div class="image-div">
              <img
                v-if="studentProfileAuthorize == ''"
                style="
                  border: 1px solid #eee;
                  width: 60px;
                  height: 60px;
                  object-fit: cover;
                "
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 60px;
                  height: 60px;
                "
                :src="photoURL"
                class="grey lighten-2 mt-2"
              />
            </div>
          </CCol>
          <CCol sm="7">
            <h4 class="mt-2">
              <strong> {{ user.name }}</strong>
            </h4>
            <div class="small text-muted">{{ user.userType }}</div>
          </CCol>
          <CCol sm="4">
          </CCol>
        </CRow>
      </div>
    </div>

    <div class="d-sm-flex d-md-none" id="custom-header-bg-sm">
      <img style="max-width: 100%" src="../assets/img/bgProfile.png" />
      <div id="examplesm" class="box-shadow-profile">
        <div class="row">
          <div style="width: 30%">
            <div class="ml-3">
              <img
                v-if="studentProfileAuthorize == ''"
                style="
                  border: 1px solid #eee;
                  width: 60px;
                  height: 60px;
                  object-fit: cover;
                "
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 60px;
                  height: 60px;
                "
                :src="photoURL"
                class="grey lighten-2 mt-2"
              />
            </div>
          </div>
          <div style="width: 70%">
            <h5 class="mt-2">
              <strong> {{ user.name }}</strong>
            </h5>
            <div class="small text-muted">{{ user.userType }}</div>
          </div>
          <div class="text-center" style="width: 100%">
            <div style="width: 100%">
            </div>
          </div>
        </div>
      </div>
    </div>

    <CCol sm="12" class="m-0 p-0">
      <CRow>
        <CCol sm="4">
          <CCard class="box-shadow-dashboard">
            <div class="p-3">
              <h5>Students</h5>
              <br /><br />
              <div style="overflow-x: hidden" class="custom-height-performance">
                <CRow
                  v-for="(item, index) in childs.Students"
                  v-bind:key="item.Id"
                >
                  <CCol sm="3">
                    <img
                      v-if="item.profileImagePath == null"
                      style="
                        border: 1px solid #eee;
                        width: 60px;
                        height: 60px;
                        object-fit: cover;
                      "
                      src="../assets/img/default.png"
                      class="grey lighten-2 mt-2"
                    />

                    <img
                      v-else
                      style="
                        border: 3px solid #ddd;
                        background: #fff;
                        width: 60px;
                        height: 60px;
                        object-fit: cover;
                      "
                      :src="getPicChild(index)"
                      class="grey lighten-2 mt-2"
                    />
                  </CCol>
                  <CCol sm="9">
                    <div>
                      <span> {{ item.studentName }}</span>
                      <br />
                      <div class="small text-muted">{{ item.grade }}</div>
                    </div>
                  </CCol>
                </CRow>
              </div>
            </div>
            <br /><br />
          </CCard>
        </CCol>
        <CCol sm="4">
          <CCard class="box-shadow-dashboard">
            <div class="p-3">
              <h5>Notification space</h5>
              <div class="small text-muted">
                This is the notification center for all messages and it’s also
                can be found in the notification screen in the Pickiddo App
                <br />
                <br />
              </div>
              <hr />

              <div style="overflow-x: hidden" class="custom-height-performance">
                <CRow
                  v-for="(item, index) in noti"
                  v-bind:key="item.Id"
                  style="cursor: pointer"
                >
                  <CCol sm="2"
                    ><img
                      style="max-width: 20px"
                      src="../assets/img/iconNoti.png"
                    />
                  </CCol>
                  <CCol sm="10">
                    <div @click="GetMessageNoti(index)">
                      <strong> {{ item.dataMessage }}</strong>
                      <br />
                      <span class="small text-muted">
                        {{ item.description }}</span
                      >
                      <br />
                      <CRow>
                        <CCol sm="6">
                          <span v-if="item.notiType === 'notification'">
                            <CBadge
                              style="background: #f09427"
                              color="orange"
                              class="text-white"
                              >Pickiddo</CBadge
                            ></span
                          >
                          <span v-else>
                            <CBadge
                              style="background: #09168a"
                              color="blue"
                              class="text-white"
                              >{{ item.notiType }}
                            </CBadge>
                          </span>
                        </CCol>
                        <CCol sm="6">
                          <div class="small text-muted">
                            {{ item.createdTime | moment("DD MMM YYYY HH:mm") }}
                          </div>
                        </CCol>
                      </CRow>
                    </div>
                  </CCol>
                </CRow>
              </div>
            </div>
          </CCard>
        </CCol>
        <CCol sm="4">
          <CCard class="box-shadow-dashboard">
            <div class="p-3">
              <h5>Message</h5>
              <p class="small text-muted">
                Detail of every selected notification
              </p>
              <div
                style="
                  width: 100%;
                  height: 20px;
                  border-bottom: 1px solid #d8dbe0;
                  text-align: center;
                "
                class="mb-4"
              >
                <span
                  style="
                    font-size: 15px;
                    background-color: #fff;
                    padding: 0 10px;
                  "
                >
                  <img
                    style="max-width: 50px"
                    src="../assets/img/iconNoti.png"
                  />
                </span>
              </div>
              <div class="custom-height-performance">
                <div class="p-3">
                  <CRow v-for="item in detail" v-bind:key="item.Id">
                    <h5>
                      {{ item.dataMessage }}
                    </h5>
                    <br />
                    <CCol sm="12"
                      ><h5 class="mt-3 text-left">
                        <strong>Description</strong>
                      </h5></CCol
                    >
                    <h6>
                      {{ item.description }}
                    </h6>
                  </CRow>
                </div>
              </div>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CCol>

    <CCol sm="12" class="m-0 p-0">
      <CRow>
        <CCol sm="12">
          <CCard class="box-shadow-dashboard">
            <h6 class="ml-3 mt-3"><strong>Offers</strong></h6>
            <p class="ml-3">List of available offer in Pickiddo Platform</p>
            <CCol sm="12" class="mt-2 mb-3">
              <CRow>
                <CCol
                  v-for="(item, index) in news.slice(0, 4)"
                  v-bind:key="item.Id"
                  sm="3"
                >
                  <a :href="GoToLink(index)">
                    <div class="text-center p-2">
                      <img
                        style="
                          max-width: 100%;
                          border-radius: 10px;
                          object-fit: cover;
                        "
                        :src="getPic(index)"
                      />
                    </div>
                  </a>
                </CCol>
              </CRow>
            </CCol>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>


<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import Page500 from "./pages/Page500.vue";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    Page500,
  },
  data() {
    return {
      backgroundUrl,
      user: {},
      studentProfile: {},
      news: [],
      student: [],
      childs: [],
      noti: [],
      detail: [],
      studentProfileAuthorize: "",
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNews();
      this.GetUserProfile();
      this.GetListChild();
      this.GetUserStudent();
      this.GetAuthorizeProfile();
      this.GetNoti();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            console.log(":testing" + this.user.id);
            this.GetAuthorizeProfile(this.user.id);
            this.GetNoti(this.user.id);
            this.GetListChild(this.user.id);
            this.GetNews();
            this.GetUserProfile(this.user.id);
            this.GetUserStudent(this.user.id);
            this.GetMessageNoti(this.user.id);
          }
        });
    },
    GetUserProfile() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfile = response.data;
          }
        });
    },
    GetNoti() {
      return this.$API
        .get(this.$NotificationAll + "?id=" + this.user.id + "&limit=100")
        .then(
          function (response) {
            console.log(response.data);
            this.noti = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GetNews() {
      this.$API.get(this.$News, { withCredentials: true }).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.news = response.data;
          this.getPic(this.news.urlImage);
          this.GoToLink(this.news.Url);
        }
      });
    },
    GetListChild() {
      this.$API
        .get(this.$StudentListAuthorize + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
            this.getPicChild(this.childs);
          }
        });
    },
    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    getPic(index) {
      return this.news[index].urlImage;
    },
    getPicChild(index) {
      return (
        "https://pickiddo.com" + this.childs.Students[index].profileImagePath
      );
    },
    GoToLink(index) {
      return this.news[index].Url;
    },

    GetMessageNoti(index) {
      return this.$API
        .get(
          this.$NotificationAllDetail +
            "?id=" +
            this.user.id +
            "&take=" +
            this.noti[index].ID
        )
        .then(
          function (response) {
            console.log(response.data[index]);
            this.detail = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
  },
};
</script>